import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const DataItem = ({
    label,
    value,
    unit,
    size = 'medium',
    labelSx = {},
    boxSx = {},
    valueSx = {},
    unitSx = {},
    sx = {},
    ...props
}) => {
    const theme = useTheme();

    const containerStyles = {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        ...sx,
    };

    const labelStyles = {
        fontSize: size === 'small' ? '12px' : size === 'medium' ? '12px' : '16px',
        color: theme.palette.figma.white[60],
        fontWeight: 400,
        letterSpacing: size === 'small' ? '-0.36px' : size === 'medium' ? '-0.36px' : '-0.48px',
        lineHeight: 'normal',
        ...labelSx,
    };

    const boxStyles = {
        display: 'flex',
        gap: '5px',
        alignItems: 'center',
        ...boxSx,
    };

    const valueStyles = {
        fontSize: size === 'small' ? '12px' : size === 'medium' ? '20px' : '40px',
        fontWeight: 600,
        letterSpacing: size === 'small' ? '-0.36px' : size === 'medium' ? '-0.6px' : '-1.2px',
        lineHeight: 'normal',
        ...valueSx,
    };

    const unitStyles = {
        fontSize: size === 'v' ? '12px' : size === 'medium' ? '12px' : '14px',
        color: theme.palette.figma.white[60],
        fontWeight: 500,
        letterSpacing: size === 'small' ? '-0.36px' : size === 'medium' ? '-0.36px' : '-0.42px',
        lineHeight: 'normal',
        ...unitSx,
    };

    return (
        <Box sx={containerStyles} {...props}>
            <Typography sx={labelStyles}>
                {label}
            </Typography>
            <Box
                sx={boxStyles}
            >
                <Typography sx={valueStyles}>
                    {typeof value === 'number' ? value.toLocaleString() : value}
                </Typography>
                <Typography sx={unitStyles}>
                    {unit}
                </Typography>
            </Box>
        </Box>
    );
};

export default DataItem;
